import { useRef, useState } from 'react';
import * as XLSX from 'xlsx';
import { Upload } from '../../lib/icons';
import { toast } from 'sonner';
import { importerContactsExcel } from '../../lib/dataProvider';

export const ImportContactsButton = ({ onDone }) => {
  const ref = useRef(null);
  const [enCours, setEnCours] = useState(false);

  const importer = async (fichier) => {
    if (!fichier) return;
    setEnCours(true);
    try {
      const wb = XLSX.read(await fichier.arrayBuffer(), { type: 'array' });
      const feuilles = Object.fromEntries(
        wb.SheetNames.map((n) => [n, XLSX.utils.sheet_to_json(wb.Sheets[n], { header: 1, defval: null })])
      );
      const r = await importerContactsExcel(feuilles);
      if (r.error) toast.error(r.error);
      else {
        toast.success(`Import terminé : ${r.ajoutes} contact(s) ajouté(s), ${r.enrichis} enrichi(s) — ${r.total} au total`);
        onDone?.();
      }
    } catch (e) {
      toast.error(`Fichier illisible : ${e.message}`);
    } finally {
      setEnCours(false);
      if (ref.current) ref.current.value = '';
    }
  };

  return (
    <label
      data-testid="import-contacts-btn"
      className={`flex h-11 cursor-pointer items-center gap-2 border-2 border-slate-900 px-4 font-heading text-sm font-bold text-slate-900 transition-colors duration-150 hover:bg-slate-900 hover:text-white sm:h-10 ${enCours ? 'pointer-events-none opacity-60' : ''}`}
    >
      <Upload size={16} /> {enCours ? 'Import…' : 'Importer Excel'}
      <input
        ref={ref}
        data-testid="import-contacts-fichier"
        type="file"
        accept=".xlsx,.xls,.csv"
        className="hidden"
        onChange={(e) => importer(e.target.files?.[0])}
      />
    </label>
  );
};
